export type OrderFields = 'name' | 'memberType'

export enum MemberTypes {
  ADMIN = 'ADMIN',
  MODERATOR = 'MODERATOR',
  FOLLOWER = 'FOLLOWER'
}

export enum TabTypes {
  ADMIN = MemberTypes.ADMIN,
  MODERATOR = MemberTypes.MODERATOR,
  FOLLOWER = MemberTypes.FOLLOWER,
  IMPORT_HISTORY = 'IMPORT_HISTORY'
}

export type MemberTypeKeys = `${MemberTypes}`
